var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDouvleQuoteAlphabet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.75H9.75L11.25 12.75V8.25H6.75V12.75H9L7.5 15.75ZM13.5 15.75H15.75L17.25 12.75V8.25H12.75V12.75H15L13.5 15.75Z",
    fill: "#8897AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDouvleQuoteAlphabet);
export default __webpack_public_path__ + "static/media/douvleQuote-alphabet.58285fcb932728e46f52aafc80f1fb3a.svg";
export { ForwardRef as ReactComponent };